import { render, staticRenderFns } from "./businessAccident.vue?vue&type=template&id=7460313d&scoped=true"
import script from "./businessAccident.vue?vue&type=script&lang=js"
export * from "./businessAccident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7460313d",
  null
  
)

export default component.exports